import script from "./cooperation.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperation.vue?vue&type=script&setup=true&lang=js"

import "./cooperation.vue?vue&type=style&index=0&id=00cddfe5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\cgproject\\canggu-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cddfe5"]])

export default __exports__